import React from 'react';
import TestContentShapeImg1 from "../../assets/images/shapes/testimonial-three-shape-1.png";
import ContentImg1 from "../../assets/images/shapes/services-details-content-shape-1.png"
import marketContentIMg from "../../assets/images/services/digital-market-content-img.jpg"

function DigitalMarketContent() {
  return (
    <div>
      <section className="digital-market-content">
        <div className="services-details-content-shape-1">
          <div className="animation_image_zoom">
            <div className="services-details-content-shape-1-img">
              <img
                src={TestContentShapeImg1}
                alt="testimonial-three-shape-1"
              />
            </div>
          </div>
        </div>
        <div className="services-details-content-shape-2">
          <div className="animation_image_zoom">
            <div className="services-details-content-shape-2-img">
              <img
                src={ContentImg1}
                alt="services-details-content-shape-1"
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="digital-market-content-title-box">
            <div
              className="section-three-title wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-three-title-title">
                <h2>
                  Build an Efficient Digital Marketing with our Marketing
                  Expertise
                </h2>
              </div>
            </div>
            <div
              className="section-three-details wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <p>
                Digital marketing &amp; advertising approach focuses on
                capturing the essential
              </p>
            </div>
          </div>
          <div
            className="digital-market-content-img-box wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="500ms"
          >
            <div className="scroll_item_select_img ">
              <img
                src={marketContentIMg}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default DigitalMarketContent
